(() => {
  const drawer = document.getElementById('hm-cart-drawer');
  if (!drawer) return;

  const panel = drawer.querySelector('.hm-cart-drawer__panel');
  const itemsRoot = drawer.querySelector('[data-hm-cart-items]');
  const footer = drawer.querySelector('[data-hm-cart-footer]');
  const subtotal = drawer.querySelector('[data-hm-cart-subtotal]');
  const status = drawer.querySelector('[data-hm-cart-status]');
  let lastFocused = null;
  const inertElements = new Map();
  const isOpen = () => drawer.getAttribute('aria-hidden') === 'false';
  const focusable = () => [...panel.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), [tabindex="0"]')].filter((element) => element.getClientRects().length && !element.closest('[hidden], [inert]'));
  const lockBackground = () => {
    let branch = drawer;
    while (branch.parentElement) {
      [...branch.parentElement.children].forEach((element) => {
        if (element === branch || inertElements.has(element)) return;
        inertElements.set(element, element.inert);
        element.inert = true;
      });
      if (branch.parentElement === document.body) break;
      branch = branch.parentElement;
    }
  };
  const publishCart = (cart) => {
    if (cart && typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'hm-cart-drawer', cartData: cart });
    }
  };

  const money = (amount, currency) => new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: currency || 'EUR'
  }).format((amount || 0) / 100);

  const create = (tag, className, text) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (text !== undefined) element.textContent = text;
    return element;
  };

  const updateCount = (count) => {
    document.querySelectorAll('.hm-header__cart').forEach((link) => {
      link.setAttribute('aria-label', count ? `Panier, ${count} article${count > 1 ? 's' : ''}` : 'Panier');
      let badge = link.querySelector('.hm-header__count');
      if (count > 0 && !badge) {
        badge = create('span', 'hm-header__count');
        link.appendChild(badge);
      }
      if (badge) {
        badge.textContent = count;
        badge.hidden = count < 1;
      }
    });
  };

  const render = (cart) => {
    const focused = panel.contains(document.activeElement) ? document.activeElement : null;
    const restoreFocus = () => {
      if (!focused || focused.isConnected || !isOpen()) return;
      const replacement = [...panel.querySelectorAll('button[data-key]')].find((button) => button.dataset.key === focused.dataset.key && button.className === focused.className && button.textContent === focused.textContent);
      (replacement || focusable()[0] || panel).focus({ preventScroll: true });
    };
    itemsRoot.replaceChildren();
    updateCount(cart.item_count);

    if (!cart.item_count) {
      const empty = create('div', 'hm-cart-drawer__empty');
      empty.append(create('strong', '', 'Votre panier est vide.'), create('span', '', 'Choisissez le message qui vous ressemble.'));
      itemsRoot.appendChild(empty);
      footer.hidden = true;
      restoreFocus();
      return;
    }

    cart.items.forEach((item, index) => {
      const article = create('article', 'hm-cart-drawer__item');
      const media = create('a', 'hm-cart-drawer__item-image');
      media.href = item.url;
      if (item.image) {
        const image = create('img');
        const thumbnail = new URL(item.image, window.location.origin);
        thumbnail.searchParams.set('width', '180');
        image.src = thumbnail.href;
        image.width = 90;
        image.height = 90;
        image.decoding = 'async';
        image.alt = item.product_title || '';
        image.loading = 'lazy';
        media.appendChild(image);
      }

      const info = create('div', 'hm-cart-drawer__item-info');
      const title = create('a', '', item.product_title);
      title.href = item.url;
      info.appendChild(title);
      if (item.variant_title && item.variant_title !== 'Default Title') info.appendChild(create('p', '', item.variant_title));
      const quantity = create('div', 'hm-cart-drawer__quantity');
      quantity.setAttribute('role', 'group');
      quantity.setAttribute('aria-label', `Quantité — ${item.product_title}`);
      [-1, 1].forEach((delta) => {
        if (delta === 1) quantity.appendChild(create('span', '', String(item.quantity)));
        const button = create('button', 'hm-cart-drawer__change', delta < 0 ? '−' : '+');
        button.type = 'button';
        button.dataset.key = item.key;
        button.dataset.quantity = String(item.quantity + delta);
        button.setAttribute('aria-label', delta < 0 ? 'Diminuer la quantité' : 'Augmenter la quantité');
        quantity.appendChild(button);
      });
      info.appendChild(quantity);
      const remove = create('button', 'hm-cart-drawer__remove', 'Retirer');
      remove.type = 'button';
      remove.dataset.key = item.key;
      remove.dataset.quantity = '0';
      info.appendChild(remove);

      const price = create('strong', 'hm-cart-drawer__item-price', money(item.final_line_price, cart.currency));
      article.append(media, info, price);
      itemsRoot.appendChild(article);
    });

    subtotal.textContent = money(cart.total_price, cart.currency);
    footer.hidden = false;
    restoreFocus();
  };

  const fetchCart = async () => {
    const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Le panier ne peut pas être chargé pour le moment.');
    const cart = await response.json();
    render(cart);
    return cart;
  };

  const open = async (message = '') => {
    if (!isOpen()) lastFocused = document.activeElement;
    drawer.setAttribute('aria-hidden', 'false');
    lockBackground();
    document.body.classList.add('hm-cart-drawer-open');
    status.textContent = message;
    panel.focus({ preventScroll: true });
    try {
      return await fetchCart();
    } catch (error) {
      status.textContent = error.message;
    }
  };

  const close = () => {
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('hm-cart-drawer-open');
    inertElements.forEach((inert, element) => { element.inert = inert; });
    inertElements.clear();
    status.textContent = '';
    if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-hm-cart-open]');
    if (opener) {
      event.preventDefault();
      open();
      return;
    }
    if (event.target.closest('[data-hm-cart-close]')) close();
  });

  document.addEventListener('keydown', (event) => {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      close();
    } else if (event.key === 'Tab') {
      const elements = focusable();
      const first = elements[0] || panel;
      const last = elements[elements.length - 1] || panel;
      if (event.shiftKey && (document.activeElement === first || !elements.includes(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !elements.includes(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    }
  });
  document.addEventListener('focusin', (event) => {
    if (isOpen() && !panel.contains(event.target)) (focusable()[0] || panel).focus({ preventScroll: true });
  });

  drawer.addEventListener('click', async (event) => {
    const remove = event.target.closest('.hm-cart-drawer__remove, .hm-cart-drawer__change');
    if (!remove || drawer.getAttribute('aria-busy') === 'true') return;
    drawer.setAttribute('aria-busy', 'true');
    drawer.querySelectorAll('.hm-cart-drawer__remove, .hm-cart-drawer__change').forEach((button) => { button.disabled = true; });
    status.textContent = 'Mise à jour du panier…';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: remove.dataset.key, quantity: Number(remove.dataset.quantity) })
      });
      if (!response.ok) throw new Error('Impossible de modifier la quantité pour le moment.');
      const cart = await response.json();
      render(cart);
      publishCart(cart);
      status.textContent = '';
    } catch (error) {
      status.textContent = error.message;
    } finally {
      drawer.removeAttribute('aria-busy');
      drawer.querySelectorAll('.hm-cart-drawer__remove, .hm-cart-drawer__change').forEach((button) => { button.disabled = false; });
    }
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();

    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    try {
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Ce produit ne peut pas être ajouté au panier.');
      publishCart(await open());
    } catch (error) {
      await open(error.message);
    } finally {
      if (submit) submit.disabled = false;
    }
  }, true);
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'hm-cart-drawer' || !event.cartData) return;
      updateCount(event.cartData.item_count);
      if (isOpen()) render(event.cartData);
    });
  }
})();


